module.exports = __webpack_public_path__ + "img/farming-by-numbers--farmer.02fd2f4e.png";